import { useContext, useEffect } from "react";
import { AppContext } from "../App";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { t } from "../i18n";
import { sendEventToParent } from "../utils/helpers";
import { eventResultStatusCodesMapfre } from "../utils/symbols";
import { PromoBanner } from "../components/PromoBanner";
import { Icon } from "../components/Icon";
import { useWizardNavigation } from "../hooks/useWizardNavigation";

export const Intro = () => {
	const { promos } = useContext(AppContext);
	const { nextPage, previousPage } = useWizardNavigation();

	return (
		<>
			<Header />
			{promos && <PromoBanner />}
			<Content />
			<Footer nextPage={nextPage} previousPage={previousPage} />
		</>
	);
};

const Content = () => {
	const { data, setData, flow, openPopUpClientEdit, isTransitioning } =
		useContext(AppContext);

	useEffect(() => {
		if (flow === "mapfre") {
			setData({ ...data, phone: data.phoneNumber, shortPhone: data.phoneNumber });
		}
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		const timer = setTimeout(() => {
			if (data.status === "potential error") {
				sendEventToParent(
					eventResultStatusCodesMapfre.IN_PROGRESS,
					data,
					flow
				);
			} else if (!data.brand || !data.model) {
				sendEventToParent(
					eventResultStatusCodesMapfre.ERROR_203,
					data,
					flow
				);
			}
		}, 1000);

		return () => clearTimeout(timer);
	}, [data, flow]);

	return (
		<div
			className={
				"content kensei_03" + (isTransitioning ? " fade-in" : "")
			}
		>
			<div className="content_intro">
				<p className="intro_info">
					<strong>{data.name}</strong>,{" "}
					{t(
						"vamos a completar tu cita para un servicio de lunas en el"
					)}{" "}
					<strong>
						{t("Taller")} {data.centerName}
					</strong>
				</p>
				<p className="intro_contact">
					{t(
						"Por favor, Confirma que tus datos de contacto son correctos."
					)}
				</p>
				<div className="intro_data">
					<div className="info_client">
						<h2>
							<span>{t("Datos cliente")}</span>
							<button onPointerDown={openPopUpClientEdit}>
								<Icon name="edit" className="client_edit" />
							</button>
						</h2>
						<ul>
							<li>
								<strong>{t("Nombre:")}</strong> {data.name}
							</li>
							<li>
								<strong>{t("Teléfono:")}</strong> {data.phone}
							</li>
							<li>
								<strong>{t("Email:")}</strong> {data.email}
							</li>
						</ul>
					</div>
					<div className="info_vehicle">
						<h2>{t("Datos del vehículo")}</h2>
						<ul>
							<li>
								<strong>{t("Marca:")}</strong> {data.brand}
							</li>
							<li>
								<strong>{t("Matrícula:")}</strong> {data.plate}
							</li>
							<li>
								<strong>{t("Modelo:")}</strong> {data.model}
							</li>
							<li>
								<strong>{t("Bastidor:")}</strong> {data.chasis}
							</li>
						</ul>
					</div>
				</div>
				{/* <p className="intro_info2">
					{t(
						"Para agilizar el servicio y la disponibilidad de recambios, a continuación te vamos a solicitar información sobre el estado de la luna"
					)}
				</p> */}
			</div>
		</div>
	);
};
